module.exports = __webpack_public_path__ + "img/W-C91.8fceaf04.jpg";